import { RootState } from '@reducers/index';
import { Organisation } from 'src/types/shared/Organisation';

export const getOrganisation = (state: RootState, id: number): Organisation =>
    state.organisationsReducer.organisation[id];
export const getOrganisationIsFetching = (state: RootState): boolean =>
    state.assessmentsReducer.isFetching;
export const getOrganisationFetchError = (state: RootState): string | null =>
    state.assessmentsReducer.fetchError;

export const getOrganisationIsPatching = (state: RootState): boolean =>
    state.organisationsReducer.isPatching;
export const getOrganisationPatchSuccess = (state: RootState): boolean =>
    state.organisationsReducer.patchSuccess;
export const getOrganisationPatchError = (state: RootState): string | null =>
    state.organisationsReducer.patchError;
